export default "__VITE_ASSET__BDeO9ioq__"